import { createPortal } from 'react-dom';
import { useEffect, useState, useCallback } from 'react';

const SearchDropdownPortal = ({ children, inputRef }) => {
  const [position, setPosition] = useState({ top: 0, left: 0, width: 0 });

  const updatePosition = useCallback(() => {
    if (inputRef) {
      const rect = inputRef.getBoundingClientRect();
      setPosition({
        top: rect.bottom + 8,
        left: rect.left,
        width: rect.width
      });
    }
  }, [inputRef]);

  useEffect(() => {
    // Calculate initial position
    updatePosition();

    // Update position on scroll and window resize
    window.addEventListener('scroll', updatePosition, true); // Use capture phase
    window.addEventListener('resize', updatePosition);

    return () => {
      window.removeEventListener('scroll', updatePosition, true);
      window.removeEventListener('resize', updatePosition);
    };
  }, [updatePosition]);

  if (!inputRef) return null;

  return createPortal(
    <div
      data-search-dropdown="true"
      className="
        fixed
        bg-white
        rounded-2xl
        shadow-[0_20px_50px_rgba(0,0,0,0.15)]
        border border-gray-100
        z-[9999]
        overflow-hidden
        animate-in fade-in zoom-in duration-300
        max-h-[60vh] overflow-y-auto
      "
      style={{
        top: `${position.top}px`,
        left: `${position.left}px`,
        width: `${position.width}px`
      }}
    >
      {children}
    </div>,
    document.body
  );
};

export default SearchDropdownPortal;
